import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './RemovedIngredients.styl';

const cx = classNames.bind(styles);

class RemovedIngredients extends PureComponent {
  static defaultProps = {
    className: '',
    list: [],
  };

  static propTypes = {
    className: PropTypes.string,
    list: PropTypes.array,
  };

  makeIngredients = () => {
    return {
      __html: this.props.list.map(ingredient => `-&nbsp;${ingredient.name}`).join(', '),
    };
  };

  render() {
    const ingredients = this.makeIngredients();
    return (
      <div
        className={cx('RemovedIngredients', this.props.className)}
        dangerouslySetInnerHTML={ingredients}
      />
    );
  }
}

export default RemovedIngredients;
